<template>
  <b-jumbotron fluid text-variant="white">
    <template v-slot:header>BAKE-U-LATER</template>
    <template v-slot:lead>A calculator for determing baker's percentages</template>
    <hr class="my-4" />
    <p>
      All ingredients revolve around the weight of the
      <b>flour</b>!
    </p>
  </b-jumbotron>
</template>

<script>
export default {
  name: 'HeroBanner'
}
</script>

<style scoped>
.jumbotron {
  padding: 1.5rem 2rem;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.9)),
    url('../../assets/hero-bread.jpg');
  background-size: cover;
  background-position-y: center;
}

hr {
  background-color: white;
}
</style>
